/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.CallCenter {
    angular.module("meevo.plugins.callCenter", []);
}